import React from "react";
import TelecareEditor from "components/Shared/TelecareEditor";

const TelecareEditorPage = () => {
  return <TelecareEditor className="is-size-7" />;
};

export default TelecareEditorPage;
